import { useEffect } from 'react'

import { Network } from '@tribeplatform/gql-client/types'
import { TribeEmitterEvent } from '@tribeplatform/react-sdk'
import { CookieCategory } from '@tribeplatform/react-sdk/types'

import { SnowplowTracker } from '../lib/snowplow.js'

import { isEnterprise } from './utils.js'

interface Props {
  networkId: Network['id']
  tracker: SnowplowTracker
}

const SCRIPT_NAME = 'snowplow'

export const useRegisterSnowplowScript = ({ networkId, tracker }: Props) => {
  useEffect(() => {
    if (isEnterprise(networkId)) {
      return
    }

    const register = () => {
      const isRegistered = window.BM.scriptManager.isRegistered(SCRIPT_NAME)
      if (isRegistered) {
        return
      }

      window.BM.scriptManager.register({
        name: SCRIPT_NAME,
        consentCategory: CookieCategory.Analytics,
        load: () => tracker.init(),
        unload: () => tracker.stop(),
      })
    }

    if (window.BM?.scriptManager) {
      register()
    } else {
      window.BM.on(TribeEmitterEvent.READY, register)
    }
  }, [networkId, tracker])
}
